import _styled from "styled-components";
var _UserApps, _UserApps2, _Settings;
import UserApps from '@crehana/icons/fill/UserApps';
import Settings from '@crehana/icons/outline/Settings';
import { useTranslation } from "../../../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ManualHighQualityWarning = function ManualHighQualityWarning(_ref) {
  var isXxs = _ref.isXxs;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (isXxs) {
    return /*#__PURE__*/_jsxs("p", {
      className: "h-48 flex items-center text-secondary-lighter font-subtitle4",
      children: [_UserApps || (_UserApps = /*#__PURE__*/_jsx(UserApps, {
        className: "text-secondary-light fill-current flex-shrink-0 mr-4",
        size: 24,
        ignoreColor: true
      })), t('MANUAL_HIGH_QUALITY_WARNING_TITLE')]
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "flex items-start py-12",
    children: [_UserApps2 || (_UserApps2 = /*#__PURE__*/_jsx(UserApps, {
      className: "text-secondary-light fill-current flex-shrink-0 mr-4",
      size: 24,
      ignoreColor: true
    })), /*#__PURE__*/_jsxs("p", {
      children: [/*#__PURE__*/_jsxs("span", {
        className: "text-secondary-lighter font-subtitle4",
        children: [t('MANUAL_HIGH_QUALITY_WARNING_TITLE'), ' ']
      }), /*#__PURE__*/_jsxs(_StyledSpan, {
        className: "font-body4 text-gray-main",
        children: [t('MANUAL_HIGH_QUALITY_WARNING_CTA'), ' ', _Settings || (_Settings = /*#__PURE__*/_jsx(Settings, {
          className: "fill-current flex-shrink-0",
          size: 16,
          ignoreColor: true
        }))]
      })]
    })]
  });
};
export default ManualHighQualityWarning;
var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  componentId: "sc-1ntgal2-0"
})(["\n            & > svg {\n              margin-bottom: -3px;\n            }\n          "]);